var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlarna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.167,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "#FEB4C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.936 15.38H4.553V9h1.383v6.38zM9.39 9H8.037c0 1.174-.51 2.252-1.4 2.957l-.536.425L8.18 15.38h1.708l-1.912-2.76C8.882 11.667 9.39 10.382 9.39 9zm2.207 6.378H10.29V9h1.307v6.377zm3.947-4.411v.282a2.104 2.104 0 0 0-1.237-.404c-1.214 0-2.199 1.042-2.199 2.327 0 1.286.985 2.328 2.2 2.328.458 0 .884-.15 1.236-.404v.282h1.248v-4.411h-1.248zm-.004 2.205c0 .627-.506 1.135-1.13 1.135-.625 0-1.131-.508-1.131-1.135 0-.626.506-1.134 1.13-1.134.625 0 1.131.508 1.131 1.134zm13.17-1.923v-.282h1.247v4.41H28.71v-.281a2.105 2.105 0 0 1-1.237.404c-1.214 0-2.199-1.042-2.199-2.328 0-1.285.985-2.327 2.2-2.327.458 0 .884.15 1.236.404zm-1.135 3.058c.624 0 1.13-.508 1.13-1.135 0-.626-.506-1.134-1.13-1.134-.625 0-1.131.508-1.131 1.134 0 .627.506 1.135 1.13 1.135zm2.924.335c0-.458.35-.829.783-.829.432 0 .783.371.783.83 0 .457-.35.828-.783.828-.433 0-.783-.371-.783-.829zm-7.444-3.794c-.498 0-.97.164-1.285.616v-.497h-1.243v4.41h1.258V13.06c0-.67.425-1 .937-1 .548 0 .864.347.864.99v2.328h1.246v-2.805c0-1.027-.771-1.725-1.777-1.725zm-4.332.119v.574c.25-.344.716-.574 1.223-.574v1.284h-.015c-.494 0-1.206.373-1.206 1.068v2.059h-1.28v-4.411h1.278z",
    fill: "#17120F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.167,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F5F5FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlarna);
export default __webpack_public_path__ + "static/media/klarna.da75730ad8e1114c41b6333419cbfc05.svg";
export { ForwardRef as ReactComponent };